module.exports = __webpack_public_path__ + "static/img/G7_V3.0105c03.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/captation/img/G7_V3.png
// module id = QCR9
// module chunks = 1